import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import ProductsHero from './components/ProductsHero';
import ProductsOverview from './components/ProductsOverview';
import ProductPQernel from './components/ProductPQernel';
import ProductPQMB from './components/ProductPQMB';
import ProductRvPlastics from './components/ProductRvPlastics';
import ProductsCTA from './components/ProductsCTA';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://www.juuliang.com';

export default function Products() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '產品與材料｜PQernel®、PQMB、rvPlastics — 聚量應用材料再生塑料解決方案',
      en: 'Products & Materials | PQernel®, PQMB, rvPlastics — PolyQ Applied Materials Recycled Plastic Solutions',
      ja: '製品・材料 | PQernel®・PQMB・rvPlastics — 聚量応用材料再生プラスチックソリューション',
    },
    description: {
      zh: '聚量提供 PQernel® 奈米擴鏈劑、PQMB 母粒與 rvPlastics 再生複合塑料，協助塑膠回收廠、造粒廠與製造商導入高比例再生料，實現低碳材料與循環經濟目標。',
      en: 'PolyQ offers PQernel® nano chain extender, PQMB masterbatch, and rvPlastics recycled composite plastics to help plastic recyclers, compounders, and manufacturers adopt high recycled content, achieving low-carbon material and circular economy goals.',
      ja: '聚量はPQernel®ナノ鎖延長剤・PQMBマスターバッチ・rvPlastics再生複合プラスチックを提供し、プラスチックリサイクル業者・造粒業者・メーカーが高再生材料比率を導入して低炭素材料とサーキュラーエコノミー目標を達成できるよう支援します。',
    },
    keywords: {
      zh: 'PQernel, PQMB, rvPlastics, rvPET, 再生塑料, 奈米擴鏈劑, 母粒, 再生複合塑料, 塑膠添加劑, 循環經濟材料, 低碳材料, 塑膠回收產品, 聚量應用材料',
      en: 'PQernel, PQMB, rvPlastics, rvPET, recycled plastics, nano chain extender, masterbatch, recycled composite plastics, plastic additives, circular economy materials, low-carbon materials, plastic recycling products, PolyQ Applied Materials',
      ja: 'PQernel, PQMB, rvPlastics, rvPET, 再生プラスチック, ナノ鎖延長剤, マスターバッチ, 再生複合プラスチック, プラスチック添加剤, サーキュラーエコノミー材料, 低炭素材料, プラスチックリサイクル製品, 聚量応用材料',
    },
    path: '/products',
    jsonLd: {
      '@type': 'ItemList',
      name: (lang === 'en' ? 'Products & Materials' : lang === 'ja' ? '製品・材料' : '產品與材料'),
      url: siteUrl + '/products',
      description: (lang === 'en'
        ? 'PolyQ offers PQernel® nano chain extender, PQMB masterbatch, and rvPlastics recycled composite plastics.'
        : lang === 'ja'
          ? '聚量はPQernel®ナノ鎖延長剤・PQMBマスターバッチ・rvPlastics再生複合プラスチックを提供します。'
          : '聚量提供 PQernel® 奈米擴鏈劑、PQMB 母粒與 rvPlastics 再生複合塑料。'),
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'PQernel® 奈米擴鏈補強劑' },
        { '@type': 'ListItem', position: 2, name: 'PQMB PolyQuantum Masterbatch 高濃度母粒' },
        { '@type': 'ListItem', position: 3, name: 'rfPlastics / rvPET 強化再生材料' },
        { '@type': 'ListItem', position: 4, name: 'rvPlastics 再生複合塑料' },
      ],
    },
  });

  return (
    <PageLayout>
      <ProductsHero />
      <ProductsOverview />
      <ProductPQernel />
      <ProductPQMB />
      <ProductRvPlastics />
      <ProductsCTA />
    </PageLayout>
  );
}